import React, { isValidElement } from "react";
import { PopupButton } from "@typeform/embed-react";

// Hooks
import { useIntl } from "react-intl";

// Components
import Modal from "@Components/Modal";
import Button from "../../overrides/venia-ui/components/Button";
import Icon from "../Icon";
var FeedbackModal = _ref => {
  var {
    onClose,
    onContinue,
    error,
    title,
    subtitle,
    cta_label_1,
    cta_label_1_subtitle,
    cta_label_2,
    extraContent,
    children,
    hide_icon = false,
    isModalOpen,
    modalId,
    bkgColor,
    feedbackTypeformId = false,
    typeformHidden,
    onModalClose = null,
    customZIndex,
    closeButton = true
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  var bg = {
    backgroundColor: bkgColor ? bkgColor : error ? "#992631" : "#86bca7"
  };
  return /*#__PURE__*/React.createElement(Modal, {
    id: modalId,
    nameClass: "modal-feedback",
    position: "uk-position-center",
    modalDialogClass: "uk-text-center section-full-rounded",
    animation: "uk-animation-scale-up",
    modalCloseOutside: true,
    isOpen: isModalOpen,
    onClose: onModalClose ? onModalClose : onClose,
    preventBgClose: true,
    closeButton: closeButton,
    customZIndex: customZIndex
  }, /*#__PURE__*/React.createElement("div", {
    "data-uk-overflow-auto": true,
    className: "feedback-container section-full-rounded uk-flex uk-flex-column uk-flex-middle uk-text-center",
    style: bg
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column uk-padding-small uk-padding-remove-vertical uk-margin-auto"
  }, hide_icon ? null : /*#__PURE__*/React.createElement(Icon, {
    name: error ? "icon-close" : "icon-check",
    color: error ? "miscusi-red" : "green"
  }), title ? /*#__PURE__*/React.createElement("h2", {
    className: "uk-text-uppercase uk-text-white title uk-margin-small-top "
  }, typeof title === "string" ? formatMessage({
    id: title && title !== " " ? title : "empty"
  }) : isValidElement(title) && title) : null, subtitle ? /*#__PURE__*/React.createElement("div", {
    className: "info uk-text-white uk-padding-medium-small"
  }, typeof subtitle === "string" ? formatMessage({
    id: subtitle && subtitle !== " " ? subtitle : "empty"
  }) : isValidElement(subtitle) && subtitle) : null, children, /*#__PURE__*/React.createElement("hr", {
    style: {
      marginTop: "20px"
    }
  })), extraContent, /*#__PURE__*/React.createElement("div", {
    className: "buttons uk-flex uk-width-1-1 uk-padding-small",
    style: {
      gap: "10px"
    }
  }, cta_label_2 ? /*#__PURE__*/React.createElement(Button, {
    color: "white",
    fullScreen: true,
    height: "small",
    type: "button",
    onClick: onContinue,
    style: {
      borderRadius: "10px",
      margin: "unset"
    }
  }, formatMessage({
    id: cta_label_2
  })) : null, cta_label_1 ? /*#__PURE__*/React.createElement(Button, {
    color: error ? "white" : "primary",
    fullScreen: true,
    height: "small",
    type: "button",
    onClick: onClose,
    style: {
      borderRadius: "10px",
      margin: "unset"
    }
  }, formatMessage({
    id: cta_label_1
  }), cta_label_1_subtitle && /*#__PURE__*/React.createElement("div", {
    className: "uk-text-xsmall uk-text-normal uk-text-lowercase"
  }, formatMessage({
    id: cta_label_1_subtitle
  }))) : null)));
};
export default FeedbackModal;